// The classes of the action buttons of an opened card («Apri link esterno»,
// «Rielabora con AI», news/NewsActions.tsx), and of a router link drawn as one
// of them without the icon: the ways back of the pages («Torna alle news»,
// «Torna alla seduta», «Torna alle sedute») and «Apri il documento completo»
// of a sitting. A module of its own, with no component: InDevelopment.tsx
// draws a way back, and NewsActions.tsx imports InDevelopment.tsx.
import { buttonVariants } from "@heroui/react";

/** The classes of the card's two action buttons, «Apri link esterno» and «Rielabora con AI». */
export const ACTION_CLASS = "h-8 gap-1 rounded-2xl bg-accent px-3 py-1.5 text-sm leading-5 font-medium text-accent-foreground";

/**
 * A router Link drawn as an action button, without an icon: HeroUI's button
 * at size sm (hover, press and focus ring come from its CSS, which a link
 * takes as well), then ACTION_CLASS. It stays a link: role, href, a new tab
 * with the middle button.
 */
export const ACTION_LINK_CLASS = `${buttonVariants({ size: "sm" })} ${ACTION_CLASS}`;
